webpackJsonp([1],{

/***/ "3jmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9c6/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G7HT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJgV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0dba586","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("GJgV")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-a0dba586"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-136b2108","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("G7HT")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78103723","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("9c6/")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutubeOrOlympics: function isYoutubeOrOlympics() {
      return this.videoURL.search('youtube') !== -1 || this.videoURL.search('olympic') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c81c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutubeOrOlympics)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("3jmS")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35db5a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("dUvF")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "ATP Tour Sustainability Report 2025",
  "shortTitle": "",
  "description": "",
  "width": 1263,
  "height": 893,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "/2025",
  //  "basePath": "", 
  "companyLogo": "1-logo-1.png",
  "publishURL": "",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "subscribeEnabled": true,
    "downloadEnabled": false,
    "downloadPath": false,
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n\n\n      <!-- popup-1 CARBON -->\n      \n      <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click\" style=\"top:377px;left:214px;\" onclick=\"showOverlay('1-pop-1')\" src=\"/2025/static/_content/1-click-1.png\"/>\n      <div id=\"1-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 1-pop-1\" style=\"top:0px;left:22px;\" src=\"/2025/static/_content/1-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopOne()\"></div>\n\n        <!-- pop-1-clicks CARBON -->\n\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click-1\" style=\"top:478px;left:1019px;\" onclick=\"openPop('1-carbontracker', '1-carbontracker-1')\" src=\"/2025/static/_content/1-click-1-green.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click-1\" style=\"top:786px;left:945px;\" onclick=\"openPop('1-carbontracker', '1-carbontracker-2')\" src=\"/2025/static/_content/1-click-1-green.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click-1\" style=\"top:786px;left:360px;\" onclick=\"openPop('1-carbontracker', '1-carbontracker-3')\" src=\"/2025/static/_content/1-click-1-green.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click-1\" style=\"top:296px;left:736px;\" onclick=\"openPop('1-carbontracker', '1-carbontracker-4')\" src=\"/2025/static/_content/1-click-1-white.png\"/>\n\n        <!-- pop-ups CARBON -->\n\n        <div id=\"1-carbontracker-1\" class=\"1-carbontracker hidden noclick\">\n          <img class=\"abs halfScale 1-pop-1-1\" style=\"top:105px;left:612px;\" src=\"/2025/static/_content/1-pop-1-1.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:105px;left:1151px;width:41px;height:42px;\" onclick=\"closePop('1-carbontracker')\"></div>\n        </div>\n\n        <div id=\"1-carbontracker-2\" class=\"1-carbontracker hidden noclick\">\n          <img class=\"abs halfScale 1-pop-1-2\" style=\"top:105px;left:612px;\" src=\"/2025/static/_content/1-pop-1-2.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:105px;left:1151px;width:41px;height:42px;\" onclick=\"closePop('1-carbontracker')\"></div>\n        </div>\n\n        <div id=\"1-carbontracker-3\" class=\"1-carbontracker hidden noclick\">\n          <img class=\"abs halfScale 1-pop-1-3\" style=\"top:158px;left:352px;\" src=\"/2025/static/_content/1-pop-1-3.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:808px;left:473px;width:41px;height:42px;\" onclick=\"closePop('1-carbontracker')\"></div>\n        </div>\n\n        <div id=\"1-carbontracker-4\" class=\"1-carbontracker hidden noclick\">\n          <img class=\"abs halfScale 1-pop-1-4\" style=\"top:128px;left:385px;\" src=\"/2025/static/_content/1-pop-1-4.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:128px;left:866px;width:41px;height:42px;\" onclick=\"closePop('1-carbontracker', '1-carbontracker-4')\"></div>\n        </div>\n\n      </div>\n\n\n      <!--- popup-2 NITTO --->\n\n      <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click\" style=\"top:89px;left:603px;\" onclick=\"openOnePopTwo()\" src=\"/2025/static/_content/1-click-2.png\"/>\n      <div id=\"1-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 1-pop-2\" style=\"top:0px;left:40px;\" src=\"/2025/static/_content/1-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n\n        <!--- animations --->\n        <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:263px;left:1094px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\"  data-number='{\"to\": 70, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC pop-2-text\" style=\"top:287px;left:1065px;\" src=\"/2025/static/_content/1-pop-2-text-1.png\"/>\n        <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:408px;left:1088px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\"  data-number='{\"to\": 673}' ></h1>\n        <img class=\"abs halfScaleC pop-2-text\" style=\"top:417px;left:1035px;\" src=\"/2025/static/_content/1-pop-2-text-2.png\"/>\n        <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:534px;left:955px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11000, \"comma\": true}' ></h1>\n        <img class=\"abs halfScaleC pop-2-text\" style=\"top:577px;left:944px;\" src=\"/2025/static/_content/1-pop-2-text-3.png\"/>\n        <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:521px;left:812px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2500, \"comma\": true}' ></h1>\n        <img class=\"abs halfScale pop-2-text\" style=\"top:571px;left:810px;\" src=\"/2025/static/_content/1-pop-2-text-4.png\"/>\n        <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:447px;left:712px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\"  data-number='{\"to\": 42, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC pop-2-text\" style=\"top:487px;left:674px;\" src=\"/2025/static/_content/1-pop-2-text-5.png\"/>\n        <img class=\"abs halfScaleC pop-2-text\" style=\"top:368px;left:615px;\" src=\"/2025/static/_content/1-pop-2-text-6.png\"/>\n        <img class=\"abs halfScaleC pop-2-text-7\" style=\"top:328px;left:662px;\" src=\"/2025/static/_content/1-pop-2-text-7.png\"/>\n        <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:227px;left:721px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\"  data-number='{\"to\": 75, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC pop-2-text\" style=\"top:260px;left:656px;\" src=\"/2025/static/_content/1-pop-2-text-8.png\"/>\n        \n\n        <!--- popup clicks NITTO --->\n\n        <img class=\"abs halfScaleC pointer 2-click\" style=\"top:638px;left:573px;\" onclick=\"openPop('1-nitto-atp', '1-nitto-atp-1')\" src=\"/2025/static/_content/1-box.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 2-click\" style=\"top:738px;left:605px;\" onclick=\"openPop('1-nitto-atp', '1-nitto-atp-1')\" src=\"/2025/static/_content/2-click-1.png\"/>\n        <img class=\"abs halfScaleC pointer 2-click\" style=\"top:638px;left:750px;\" onclick=\"openPop('1-nitto-atp', '1-nitto-atp-2')\" src=\"/2025/static/_content/1-box.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 2-click\" style=\"top:738px;left:851px;\" onclick=\"openPop('1-nitto-atp', '1-nitto-atp-2')\" src=\"/2025/static/_content/2-click-2.png\"/>\n        <img class=\"abs halfScaleC pointer 2-click\" style=\"top:638px;left:927px;\" onclick=\"openPop('1-nitto-atp', '1-nitto-atp-3')\" src=\"/2025/static/_content/1-box.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 2-click\" style=\"top:738px;left:965px;\" onclick=\"openPop('1-nitto-atp', '1-nitto-atp-3')\" src=\"/2025/static/_content/2-click-3.png\"/>\n     \n        <!--- pop-up environment --->\n\n        <div id=\"1-nitto-atp-1\" class=\"1-nitto-atp hidden noclick\">\n          <img class=\"abs halfScale 1-pop-2-1\" style=\"top:38px;left:39px;\" src=\"/2025/static/_content/1-pop-2-1.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:60px;left:1157px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n\n          <!--- environment clicks --->\n      \n          <img class=\"abs halfScaleC pointer click-2\" style=\"top:95px;left:-25px;\" onclick=\"openPop('1-nitto-atp-env', '1-nitto-atp-4')\" src=\"/2025/static/_content/click-2-1.png\"/>\n          <img class=\"abs halfScaleC pointer click-2\" style=\"top:95px;left:244px;\" onclick=\"openPop('1-nitto-atp-env', '1-nitto-atp-5')\" src=\"/2025/static/_content/click-2-2.png\"/>\n          <img class=\"abs halfScaleC pointer click-2\" style=\"top:95px;left:511px;\" onclick=\"openPop('1-nitto-atp-env', '1-nitto-atp-6')\" src=\"/2025/static/_content/click-2-3.png\"/>\n          <img class=\"abs halfScaleC pointer click-2\" style=\"top:95px;left:779px;\" onclick=\"openPop('1-nitto-atp-env', '1-nitto-atp-7')\" src=\"/2025/static/_content/click-2-4.png\"/>\n          <img class=\"abs halfScaleC pointer click-2\" style=\"top:383px;left:-25px;\" onclick=\"openPop('1-nitto-atp-env', '1-nitto-atp-8')\" src=\"/2025/static/_content/click-2-5.png\"/>\n          <img class=\"abs halfScaleC pointer click-2\" style=\"top:383px;left:244px;\" onclick=\"openPop('1-nitto-atp-env', '1-nitto-atp-9')\" src=\"/2025/static/_content/click-2-6.png\"/>\n          <img class=\"abs halfScaleC pointer click-2\" style=\"top:383px;left:511px;\" onclick=\"openPop('1-nitto-atp-env', '1-nitto-atp-10')\" src=\"/2025/static/_content/click-2-7.png\"/>\n          <img class=\"abs halfScaleC pointer click-2\" style=\"top:383px;left:779px;\" onclick=\"openPop('1-nitto-atp-env', '1-nitto-atp-11')\" src=\"/2025/static/_content/click-2-8.png\"/>\n\n          <!--- environment boxes popups --->\n          \n          <div id=\"1-nitto-atp-4\" class=\"1-nitto-atp-env hidden noclick\">\n            <img class=\"abs halfScale 1-pop-2-1-1\" style=\"top:37px;left:22px;pointer\" src=\"/2025/static/_content/1-pop-2-1-1.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:231px;left:582px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp-env')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n          </div>\n\n          <div id=\"1-nitto-atp-5\" class=\"1-nitto-atp-env hidden noclick\">\n            <img class=\"abs halfScale 1-pop-2-1-2\" style=\"top:37px;left:22px;pointer\" src=\"/2025/static/_content/1-pop-2-1-2.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:231px;left:850px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp-env')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n          </div>\n\n          <div id=\"1-nitto-atp-6\" class=\"1-nitto-atp-env hidden noclick\">\n            <img class=\"abs halfScale 1-pop-2-1-3\" style=\"top:37px;left:22px;pointer\" src=\"/2025/static/_content/1-pop-2-1-3.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:231px;left:1119px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp-env')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n          </div>\n\n          <div id=\"1-nitto-atp-7\" class=\"1-nitto-atp-env hidden noclick\">\n            <img class=\"abs halfScale 1-pop-2-1-4\" style=\"top:37px;left:22px;pointer\" src=\"/2025/static/_content/1-pop-2-1-4.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:231px;left:851px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp-env')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n          </div>\n\n          <div id=\"1-nitto-atp-8\" class=\"1-nitto-atp-env hidden noclick\">\n            <img class=\"abs halfScale 1-pop-2-1-5\" style=\"top:37px;left:22px;pointer\" src=\"/2025/static/_content/1-pop-2-1-5.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:231px;left:582px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp-env')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n          </div>\n\n          <div id=\"1-nitto-atp-9\" class=\"1-nitto-atp-env hidden noclick\">\n            <img class=\"abs halfScale 1-pop-2-1-6\" style=\"top:37px;left:22px;pointer\" src=\"/2025/static/_content/1-pop-2-1-6.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:521px;left:851px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp-env')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n          </div>\n\n          <div id=\"1-nitto-atp-10\" class=\"1-nitto-atp-env hidden noclick\">\n            <img class=\"abs halfScale 1-pop-2-1-7\" style=\"top:37px;left:22px;pointer\" src=\"/2025/static/_content/1-pop-2-1-7.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:231px;left:1119px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp-env')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n          </div>\n\n          <div id=\"1-nitto-atp-11\" class=\"1-nitto-atp-env hidden noclick\">\n            <img class=\"abs halfScale 1-pop-2-1-8\" style=\"top:37px;left:22px;pointer\" src=\"/2025/static/_content/1-pop-2-1-8.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:231px;left:849px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp-env')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n          </div>\n\n        </div>\n\n        <!--- pop-up social --->\n\n        <div id=\"1-nitto-atp-2\" class=\"1-nitto-atp hidden noclick\">\n          <img class=\"abs halfScale 1-pop-2-2\" style=\"top:38px;left:23px;\" src=\"/2025/static/_content/1-pop-2-2.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:60px;left:1157px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n        </div>\n\n        <!--- pop-up governance --->\n\n        <div id=\"1-nitto-atp-3\" class=\"1-nitto-atp hidden noclick\">\n          <img class=\"abs halfScale 1-pop-2-3\" style=\"top:38px;left:40px;\" src=\"/2025/static/_content/1-pop-2-3.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:60px;left:1157px;width:41px;height:42px;\" onclick=\"closePop('1-nitto-atp')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopTwo()\"></div>\n        </div>\n\n      </div>\n\n\n      <!--- popup-3 SPORTIMPACT --->\n\n      <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click\" style=\"top:478px;left:244px;\" onclick=\"showOverlay('1-pop-3')\" src=\"/2025/static/_content/1-click-3.png\"/>\n      <div id=\"1-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 1-pop-3\" style=\"top:0px;left:22px;\" src=\"/2025/static/_content/1-pop-3.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"hideOverlay('1-pop-3')\"></div>\n      </div>\n\n\n      <!--- popup-4 CARBONFOOTPRINT --->\n\n      <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click\" style=\"top:786px;left:504px;\" onclick=\"openOnePopFour()\" src=\"/2025/static/_content/1-click-4.png\"/>\n      <div id=\"1-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 1-pop-4\" style=\"top:0px;left:22px;\" src=\"/2025/static/_content/1-pop-4.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopFour()\"></div>\n\n        <!--- animations --->\n\n        <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:442px;left:640px; font-size: 5.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3826, \"comma\": true}' ></h1>\n        <img class=\"abs halfScaleC 4-box\" style=\"top:104px;left:493px;\" src=\"/2025/static/_content/4-box-1.png\"/>\n        <h1 id=\"1-no\" class=\"abs rocG-Cond 1-no\" style=\"top:222px;left:618px; font-size: 4.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 126}' ></h1>\n        <img class=\"abs halfScaleC 4-box\" style=\"top:563px;left:644px;\" src=\"/2025/static/_content/4-box-2.png\"/>\n        <h1 id=\"1-no\" class=\"abs rocG-Cond 1-no\" style=\"top:678px;left:735px; font-size: 4.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3700, \"comma\": true}' ></h1>\n\n      </div>\n\n\n      <!--- popup-5 FANTRAVEL --->\n\n      <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 1-click\" style=\"top:516px;left:939px;\" onclick=\"openOnePopFive()\" src=\"/2025/static/_content/1-click-5.png\"/>\n      <div id=\"1-pop-5\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 1-pop-5\" style=\"top:0px;left:22px;\" src=\"/2025/static/_content/1-pop-5.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopFive()\"></div>\n\n        <!--- popup clicks --->\n\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 5-click\" style=\"top:382px;left:249px;\" onclick=\"popFiveAnimation('1-fan-travel', '1-fan-travel-1')\" src=\"/2025/static/_content/click-5-1.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 5-click\" style=\"top:756px;left:258px;\" onclick=\"popFiveAnimation('1-fan-travel', '1-fan-travel-2')\" src=\"/2025/static/_content/click-5-2.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 5-click\" style=\"top:287px;left:626px;\" onclick=\"popFiveAnimation('1-fan-travel', '1-fan-travel-3')\" src=\"/2025/static/_content/click-5-3.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 5-click\" style=\"top:519px;left:904px;\" onclick=\"popFiveAnimation('1-fan-travel', '1-fan-travel-4')\" src=\"/2025/static/_content/click-5-3.png\"/>\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 5-click\" style=\"top:741px;left:914px;\" onclick=\"popFiveAnimation('1-fan-travel', '1-fan-travel-5')\" src=\"/2025/static/_content/click-5-3.png\"/>\n\n        <!--- popup-5: first --->\n\n        <div id=\"1-fan-travel-1\" class=\"1-fan-travel  hidden noclick\">\n          <img class=\"abs halfScale 1-pop-5-1\" style=\"top:37px;left:39px;\" src=\"/2025/static/_content/1-pop-5-1.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:775px;left:74px;width:41px;height:42px;\" onclick=\"closePop('1-fan-travel')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopFive()\"></div>\n\n          <!--- animations --->\n\n          <img class=\"abs halfScaleC 5-title\" style=\"top:147px;left:-68px;\" src=\"/2025/static/_content/5-title-1.png\"/>\n          <img class=\"abs halfScaleC 5-title\" style=\"top:206px;left:-124px;\" src=\"/2025/static/_content/5-subtext-1.png\"/>\n\n          <img class=\"abs halfScaleC 5-heading\" style=\"top:282px;left:94px;\" src=\"/2025/static/_content/5-heading-1.png\"/>\n          <img class=\"abs halfScaleC 5-arrow\" style=\"top:321px;left:-15px;\" src=\"/2025/static/_content/5-arrow-1.png\"/>\n          <img class=\"abs halfScaleC 5-arrow\" style=\"top:373px;left:-12px;\" src=\"/2025/static/_content/5-arrow-2.png\"/>\n          <img class=\"abs halfScaleC 5-arrow\" style=\"top:426px;left:-22px;\" src=\"/2025/static/_content/5-arrow-3.png\"/>\n          <img class=\"abs halfScaleC 5-line\" style=\"top:354px;left:358px;\" src=\"/2025/static/_content/5-line-1.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:333px;left:344px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:333px;left:423px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:333px;left:505px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:333px;left:588px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:333px;left:678px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:333px;left:762px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n  \n\n          <img class=\"abs halfScaleC 5-line\" style=\"top:406px;left:358px;\" src=\"/2025/static/_content/5-line-2.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:386px;left:344px;\" src=\"/2025/static/_content/5-circle-white.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:386px;left:423px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:386px;left:505px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:386px;left:588px;\" src=\"/2025/static/_content/5-circle-white.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:386px;left:678px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:386px;left:762px;\" src=\"/2025/static/_content/5-circle-white.png\"/>\n\n          <img class=\"abs halfScaleC 5-line\" style=\"top:462px;left:358px;\" src=\"/2025/static/_content/5-line-3.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:441px;left:344px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:441px;left:423px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:441px;left:505px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:441px;left:588px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:441px;left:678px;\" src=\"/2025/static/_content/5-circle-blue.png\"/>\n          <img class=\"abs halfScaleC 5-circle\" style=\"top:441px;left:762px;\" src=\"/2025/static/_content/5-circle-white.png\"/>\n\n          <img class=\"abs halfScaleC 5-heading\" style=\"top:535px;left:128px;\" src=\"/2025/static/_content/5-heading-2.png\"/>\n          <img class=\"abs halfScaleC 5-arrow-2\" style=\"top:574px;left:-15px;\" src=\"/2025/static/_content/5-arrow-4.png\"/>\n          <img class=\"abs halfScaleC 5-arrow-2\" style=\"top:636px;left:-15px;\" src=\"/2025/static/_content/5-arrow-5.png\"/>\n          <img class=\"abs halfScaleC 5-arrow-2\" style=\"top:698px;left:-31px;\" src=\"/2025/static/_content/5-arrow-6.png\"/>\n\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:530px;left:300px;\" src=\"/2025/static/_content/5-outline-1.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:587px;left:395px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 883}' ></h1>\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:520px;left:469px;\" src=\"/2025/static/_content/5-outline-2.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:587px;left:546px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 1.1, \"decimals\": 1, \"append\": \"%\"}' ></h1>\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:538px;left:569px;\" src=\"/2025/static/_content/5-outline-3.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:587px;left:694px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 2582, \"comma\": true}' ></h1>\n\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:592px;left:300px;\" src=\"/2025/static/_content/5-outline-1.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:647px;left:383px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 1575, \"comma\": true}' ></h1>\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:579px;left:470px;\" src=\"/2025/static/_content/5-outline-2.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:648px;left:546px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 1.3, \"decimals\": 1, \"append\": \"%\"}' ></h1>\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:598px;left:569px;\" src=\"/2025/static/_content/5-outline-3.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:648px;left:684px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 11953, \"comma\": true}' ></h1>\n\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:655px;left:300px;\" src=\"/2025/static/_content/5-outline-1.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:713px;left:395px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 815}' ></h1>\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:645px;left:470px;\" src=\"/2025/static/_content/5-outline-2.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:713px;left:546px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 1.9, \"decimals\": 1, \"append\": \"%\"}' ></h1>\n          <img class=\"abs halfScaleC 5-outline\" style=\"top:656px;left:569px;\" src=\"/2025/static/_content/5-outline-3.png\"/>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:714px;left:694px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;\" data-number='{\"to\": 6151, \"comma\": true}' ></h1>\n          \n          <img class=\"abs halfScaleC bluebox\" style=\"top:-320px;left:718px;\" src=\"/2025/static/_content/blue-box.png\"/>\n\n          <img class=\"abs halfScaleC 5-title-2\" style=\"top:106px;left:842px;\" src=\"/2025/static/_content/5-title-2.png\"/>\n          <img class=\"abs halfScaleC 5-subtext\" style=\"top:151px;left:785px;\" src=\"/2025/static/_content/5-subtext-2.png\"/>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:182px;left:915px; font-size: 2.7em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 43}' ></h1>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:182px;left:1001px; font-size: 2.7em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 174}' ></h1>\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:182px;left:1112px; font-size: 2.7em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 15}' ></h1>\n\n          <img class=\"abs halfScaleC 5-heading-text\" style=\"top:214px;left:775px;\" src=\"/2025/static/_content/5-heading-3.png\"/>\n\n          <img class=\"abs halfScaleC 5-subtext\" style=\"top:276px;left:811px;\" src=\"/2025/static/_content/5-subtext-3.png\"/>\n\n          <img class=\"abs halfScaleC 5-piechart\" style=\"top:304px;left:864px;\" src=\"/2025/static/_content/5-piechart-1.png\"/>\n          <img class=\"abs halfScaleC 5-piechart\" style=\"top:304px;left:961px;\" src=\"/2025/static/_content/5-piechart-2.png\"/>\n          <img class=\"abs halfScaleC 5-piechart\" style=\"top:304px;left:1056px;\" src=\"/2025/static/_content/5-piechart-3.png\"/>\n          <img class=\"abs halfScaleC 5-heading-text\" style=\"top:410px;left:775px;\" src=\"/2025/static/_content/5-heading-3.png\"/>\n\n          <img class=\"abs halfScaleC 5-subtext\" style=\"top:479px;left:768px;\" src=\"/2025/static/_content/5-subtext-4.png\"/>\n\n          <img class=\"abs halfScaleC 5-piechart-2\" style=\"top:511px;left:864px;\" src=\"/2025/static/_content/5-piechart-4.png\"/>\n          <img class=\"abs halfScaleC 5-piechart-2\" style=\"top:511px;left:961px;\" src=\"/2025/static/_content/5-piechart-5.png\"/>\n          <img class=\"abs halfScaleC 5-piechart-2\" style=\"top:511px;left:1056px;\" src=\"/2025/static/_content/5-piechart-6.png\"/>\n          <img class=\"abs halfScaleC 5-heading-text\" style=\"top:617px;left:775px;\" src=\"/2025/static/_content/5-heading-3.png\"/>\n\n          <img class=\"abs halfScaleC 5-quote\" style=\"top:675px;left:776px;\" src=\"/2025/static/_content/5-quote.png\"/>         \n        </div>\n\n        <!--- popup-5: second --->\n\n        <div id=\"1-fan-travel-2\" class=\"1-fan-travel  hidden noclick\">\n          <img class=\"abs halfScale 1-pop-5-2\" style=\"top:38px;left:22px;\" src=\"/2025/static/_content/1-pop-5-2.png\"/>\n          <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer click-5-2-2\" style=\"top:393px;left:214px;\" onclick=\"openPop('1-fan-travel-phone', '1-fan-travel-6')\" src=\"/2025/static/_content/click-5-2-3.png\"/>\n          <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer click-5-2-2\" style=\"top:347px;left:295px;\" onclick=\"openPop('1-fan-travel-phone', '1-fan-travel-6')\" src=\"/2025/static/_content/click-5-2-2.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1157px;width:41px;height:42px;\" onclick=\"closePop('1-fan-travel')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopFive()\"></div>\n\n          <div id=\"1-fan-travel-6\" class=\"1-fan-travel hidden noclick\">\n            <img class=\"abs halfScale 1-pop-5-2-1\" style=\"top:170px;left:648px;\" src=\"/2025/static/_content/1-pop-5-2-1.png\"/>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:730px;left:664px;width:41px;height:42px;\" onclick=\"closePop('1-fan-travel-phone')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:59px;left:1156px;width:41px;height:42px;\" onclick=\"closePop('1-fan-travel');closePop('1-fan-travel-phone')\"></div>\n            <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopFive()\"></div>\n          </div>\n        </div>\n\n        <!--- popup-5: third --->\n\n        <div id=\"1-fan-travel-3\" class=\"1-fan-travel hidden noclick\">\n          <img class=\"abs halfScale 1-pop-5-3-1\" style=\"top:164px;left:642px;\" src=\"/2025/static/_content/1-pop-5-3-1.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:750px;left:1105px;width:41px;height:42px;\" onclick=\"closePop('1-fan-travel')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopFive()\"></div>\n\n          <!--- animations --->\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:246px;left:670px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1575, \"comma\":true}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:246px;left:876px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11953, \"comma\":true}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:421px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 53, \"append\": \"%\"}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:655px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 73, \"append\": \"%\"}' ></h1>\n        </div>\n\n        <div id=\"1-fan-travel-4\" class=\"1-fan-travel hidden noclick\">\n          <img class=\"abs halfScale 1-pop-5-2-3\" style=\"top:164px;left:642px;\" src=\"/2025/static/_content/1-pop-5-3-2.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:750px;left:1105px;width:41px;height:42px;\" onclick=\"closePop('1-fan-travel')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopFive()\"></div>\n\n          <!--- animations --->\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:246px;left:670px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 883}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:246px;left:876px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2582, \"comma\":true}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:421px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 56, \"append\": \"%\"}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:655px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 58, \"append\": \"%\"}' ></h1>\n        </div>\n\n        <div id=\"1-fan-travel-5\" class=\"1-fan-travel hidden noclick\">\n          <img class=\"abs halfScale 1-pop-5-3-3\" style=\"top:164px;left:642px;\" src=\"/2025/static/_content/1-pop-5-3-3.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:750px;left:1105px;width:41px;height:42px;\" onclick=\"closePop('1-fan-travel')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:1px;left:1188px;width:41px;height:42px;\" onclick=\"closeOnePopFive()\"></div>\n          \n          <!--- animations --->\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:259px;left:670px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 815}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:259px;left:876px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 6151, \"comma\":true}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:433px;left:736px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 74, \"append\": \"%\"}' ></h1>\n\n          <h1 id=\"1-no\" class=\"abs rocG-CondBd 1-no\" style=\"top:667px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 80, \"append\": \"%\"}' ></h1>\n        </div>\n      </div>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n        }\n\n        function openPop(klass, id) {\n          popups = cOf(klass);\n          ele = idOf(id);\n          for(var i=0; i<popups.length; i++) {\n            popups[i].className = klass + \" hidden noclick\";\n          }\n          if(klass == \"1-fan-travel\") {\n            childs = cOf('1-fan-travel-phone')\n            for(var i=0; i<childs.length; i++) {\n              childs[i].className = '1-fan-travel-phone hidden click'\n            }\n          }\n          ele.className = klass + \" visible\"\n        }\n\n        function closePop(klass) {\n          popups = cOf(klass);\n          for(var i=0; i<popups.length; i++) {\n            popups[i].className = klass + \" hidden noclick\";\n          }\n          if(klass == \"1-nitto-atp\") {\n            childs = cOf('1-nitto-atp-env')\n            for(var i=0; i<childs.length; i++) {\n              childs[i].className = '1-nitto-atp-env hidden noclick'\n            }\n          }\n          if(klass == \"1-fan-travel\") {\n            pg1Anim.stop()\n            resetNumbers(\"1-no\")\n          }\n        }\n\n        function closeOnePopOne() {\n          hideOverlay('1-pop-1')\n          closePop('1-carbontracker')\n        }\n\n        function openOnePopTwo() {\n          showOverlay('1-pop-2');\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[0])}}, 1)\n          .fromTo(cOf(\"1-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[1])}}, 1.2)\n          .fromTo(cOf(\"1-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[2])}}, 1.4)\n          .fromTo(cOf(\"1-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[3])}}, 1.6)\n          .fromTo(cOf(\"1-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[4])}}, 1.8)\n          .fromTo(cOf(\"pop-2-text-7\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2)\n          .fromTo(cOf(\"1-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[5])}}, 2.2)\n\n          .staggerFromTo(cOf(\"pop-2-text\"), 0.6, {opacity:0, y:-10}, {opacity:1, y:0, ease: Power2.easeOut}, 0.2, 1.2);\n        }\n\n        function closeOnePopTwo() {\n          hideOverlay('1-pop-2')\n          closePop('1-nitto-atp')\n          resetNumbers(\"1-no\");\n        }\n\n        function openOnePopFour() {\n          showOverlay('1-pop-4');\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[6])}}, 1)\n          .staggerFromTo(cOf(\"4-box\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.1)\n\n          .fromTo(cOf(\"1-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[7])}}, 1.5)\n          .fromTo(cOf(\"1-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[8])}}, 1.7);\n        }\n\n        function closeOnePopFour() {\n          hideOverlay('1-pop-4')\n          resetNumbers(\"1-no\");\n        }\n\n        function openOnePopFive() {\n          showOverlay('1-pop-5');\n          resetNumbers('1-no');\n        }\n\n        function closeOnePopFive(id) {\n          hideOverlay('1-pop-5')\n          closePop('1-fan-travel')\n          resetNumbers(\"1-no\");\n        }\n\n        function popFiveAnimation(klass, id) {\n          popups = cOf(klass);\n          ele = idOf(id);\n          resetNumbers(\"1-no\");\n          pg1Anim.stop();\n\n          for(var i=0; i<popups.length; i++) {\n            popups[i].className = klass + \" hidden noclick\";\n          }\n          childs = cOf('1-fan-travel-phone')\n          childs.className = '1-fan-travel-phone hidden click'\n          ele.className = klass + \" visible\"\n\n          pg1Anim = new TimelineMax();\n\n          if(id == '1-fan-travel-1') {\n            pg1Anim.staggerFromTo(cOf(\"5-title\"), 0.6, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1)\n            .staggerFromTo(cOf(\"5-heading\"), 0.6, {opacity:0, y:-20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.6, 1.2)\n            .staggerFromTo(cOf(\"5-arrow\"), 0.5, {opacity:0, x:-20}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1.5) \n            .staggerFromTo(cOf(\"5-line\"), 1.2, {scaleX: 0, transformOrigin: \"left center\"}, {scaleX: 0.5, ease: Power2.easeOut}, 0.6, 1.7)\n            .staggerFromTo(cOf(\"5-circle\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.9)\n            .staggerFromTo(cOf(\"5-arrow-2\"), 0.5, {opacity:0, x:-20}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 2.8)\n            .staggerFromTo(cOf(\"5-outline\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.9)\n            .fromTo(cOf(\"1-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[9])}}, 2.8)\n            .fromTo(cOf(\"1-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[10])}}, 2.9)\n            .fromTo(cOf(\"1-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[11])}}, 3)\n            .fromTo(cOf(\"1-no\")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[12])}}, 3.4)\n            .fromTo(cOf(\"1-no\")[13], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[13])}}, 3.5)\n            .fromTo(cOf(\"1-no\")[14], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[14])}}, 3.6)\n            .fromTo(cOf(\"1-no\")[15], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[15])}}, 4)\n            .fromTo(cOf(\"1-no\")[16], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[16])}}, 4.3)\n            .fromTo(cOf(\"1-no\")[17], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[17])}}, 4.6)\n\n            pg1Anim.fromTo(cOf(\"bluebox\"), 0.5, {opacity:0, x:25}, {opacity:1, x:0, ease: Power2.easeOut}, 4.8)\n            .fromTo(cOf(\"5-title-2\"), 0.4, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 4.9)\n            .staggerFromTo(cOf(\"5-subtext\"), 0.4, {opacity:0, x:20}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 5)\n\n            .fromTo(cOf(\"1-no\")[18], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[18])}}, 5.1)\n            .fromTo(cOf(\"1-no\")[19], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[19])}}, 5.1)\n            .fromTo(cOf(\"1-no\")[20], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[20])}}, 5.1)\n\n            .staggerFromTo(cOf(\"5-heading-text\"), 0.4, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 0.6, 5.3)\n            .fromTo(cOf(\"5-piechart\"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 5.6)\n            .fromTo(cOf(\"5-piechart-2\"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 6.2)\n            .fromTo(cOf(\"5-quote\"), 0.8, {opacity:0, x:25}, {opacity:1, x:0, ease: Power2.easeOut}, 6.4)\n          } else if(id == '1-fan-travel-2') {\n\n          } else if(id == '1-fan-travel-3') {\n            pg1Anim.fromTo(cOf(\"1-no\")[21], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[21])}}, 1)\n            .fromTo(cOf(\"1-no\")[22], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[22])}}, 1.2)\n            .fromTo(cOf(\"1-no\")[23], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[23])}}, 1.4)\n            .fromTo(cOf(\"1-no\")[24], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[24])}}, 1.6)\n          } else if(id == '1-fan-travel-4') {\n            pg1Anim.fromTo(cOf(\"1-no\")[25], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[25])}}, 1)\n            .fromTo(cOf(\"1-no\")[26], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[26])}}, 1.2)\n            .fromTo(cOf(\"1-no\")[27], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[27])}}, 1.4)\n            .fromTo(cOf(\"1-no\")[28], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[28])}}, 1.6)\n          } else if(id == '1-fan-travel-5') {\n            pg1Anim.fromTo(cOf(\"1-no\")[29], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[29])}}, 1)\n            .fromTo(cOf(\"1-no\")[30], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[30])}}, 1.2)\n            .fromTo(cOf(\"1-no\")[31], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[31])}}, 1.4)\n            .fromTo(cOf(\"1-no\")[32], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"1-no\")[32])}}, 1.6);\n          }\n\n\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          resetNumbers(\"1-no\");\n        }\n\n      ",
    "searchText": "2025  NITTO ATP FINALS  CARBON TRACKER 2.0  SPORT IMPACT SUMMIT  FAN TRAVEL  Sustainability updates Click the panels to read more about our 2025 updates  CARBON FOOTPRINT"
  }]],
  "script": "\n          function idOf(id) {\n      return document.getElementById(id)\n    }\n\n    function cOf(klass) {\n      return document.getElementsByClassName(klass)\n    }\n    \n    function removeContentLinks() {\n      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n      contentLinks.map(function callback(e) { \n        return e.className = 'addContentLink'\n      })\n    }\n\n    function addContentLinks() {\n      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n      contentLinks.map(function callback(e) {\n        return e.className = 'contentLink addContentLink'\n      })\n    }\n\n    function showOverlay(idx) {\n      idOf(idx).className = 'contentOverlay visible'\n    }\n\n    function hideOverlay(idx) {\n      idOf(idx).className = 'contentOverlay hidden noclick'\n    }\n\n    function animateNumber(element){\n      if(element.getAttribute(\"data-number\")){\n        var args = JSON.parse(element.getAttribute(\"data-number\"));\n        var from = 0;\n        var to = 100;\n        var append = \"\";\n        var preppend = \"\";\n        var decimals = 0;\n        var duration = 1;\n        var ease = \"Linear.easeNone\";\n        var comma = false;\n        var separator = \",\";\n        var decChar = \".\";\n        for(obj in args){\n          if(obj == \"from\") from = args[obj];\n          if(obj == \"to\") to = args[obj];\n          if(obj == \"append\") append = args[obj];\n          if(obj == \"preppend\") preppend = args[obj];\n          if(obj == \"decimals\") decimals = args[obj];\n          if(obj == \"duration\") duration = args[obj];\n          if(obj == \"ease\") ease = args[obj];\n          if(obj == \"comma\") comma = args[obj];\n          if(obj == \"separator\") separator = args[obj];\n          if(obj == \"decChar\") decChar = args[obj];\n        }\n        var obj = {number: from}\n        TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n          if(comma){\n            var str = obj.number.toFixed(decimals).toString();\n            var predec = str.split(/^d*/)[0];\n            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n            var comp = newstr.replace(/^,/, '')\n            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n            // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n            var dp = \"\";\n            element.innerHTML = preppend+comp+dp+append;\n          }else{\n            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n          }\n        }, ease: eval(ease)});\n      }else{\n        return;\n      }\n    }\n\n    function resetNumbers(ele){\n      var numbers = cOf(ele)\n      for(var i=0; i<numbers.length; i++) {\n        numbers[i].innerText= \"\"\n      }\n    }\n\n    function mailChimpSubmit(){\n      $('#mc-embedded-subscribe-form').submit(function (e) {\n        var that = $(this);\n        var mailchimpSubmit = $(this).find('input[type=submit]');\n        var errorResponse = $('#mce-error-response');\n        var successResponse = $('#mce-success-response');\n\n        e.preventDefault();\n\n        $.ajax({\n          method: 'GET',\n          url: that.attr('action'),\n          data: that.serialize(),\n          dataType: 'jsonp',\n          success: function(data) {\n          // If there was an error then show the error message.\n            if (data.result === 'error') {\n              // If the error has an error code at front then alter the message to not include the error code and hyphen.\n              if(data.msg.indexOf('0') === 0) {\n                data.msg = data.msg.slice(3);\n              }\n              errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);\n            }\n            // If success then show message\n            else {\n              successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);\n            }\n          }\n        });\n      });\n    }\n  ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-EFCGXB6TPV" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dUvF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.274cdff341dbd3096cb6.js